import React, { useEffect, useState } from 'react';

export default function GlobalMouseEffect() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  // Check if we're on a special page that needs a more subtle effect
  const isSpecialPage = window.location.pathname.includes('carbon-negative-era') || 
                        window.location.pathname.includes('pride-staff') || 
                        window.location.pathname.includes('lovenood') ||
                        window.location.pathname.includes('pride-staff-presentation');

  // Check if we should disable the effect (for popups)
  const shouldDisableEffect = document.body.classList.contains('popup-open');

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const handleMouseMove = (e: MouseEvent) => {
      if (shouldDisableEffect) return;
      
      setPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
      
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsVisible(false), 100);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(timeout);
    };
  }, [shouldDisableEffect]);

  return (
    <div
      className={`fixed pointer-events-none z-50 transition-opacity duration-300 ${
        isVisible && !shouldDisableEffect ? 'opacity-100' : 'opacity-0'
      }`}
      style={{
        width: isSpecialPage ? '300px' : '600px',
        height: isSpecialPage ? '300px' : '600px',
        transform: `translate(${position.x - (isSpecialPage ? 150 : 300)}px, ${position.y - (isSpecialPage ? 150 : 300)}px)`,
        background: isSpecialPage 
          ? 'radial-gradient(circle, rgba(184, 134, 11, 0.1) 0%, transparent 70%)' 
          : 'radial-gradient(circle, rgba(184, 134, 11, 0.25) 0%, transparent 70%)',
        willChange: 'transform'
      }}
    />
  );
}